import React, { useState } from 'react';
import { Typography, IconButton, Box, Button } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import RefreshIcon from '@mui/icons-material/Refresh';

const TooltipContent = ({ reasons, theme, onRetry }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [disabled, setDisabled] = useState(false);


  if (!reasons || reasons.length === 0) return null;

  const handleNext = (e) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev + 1) % reasons.length);
  };

  const handlePrev = (e) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev - 1 + reasons.length) % reasons.length);
  };

  const handleRetry = (e) => {
    e.stopPropagation();
    if (!disabled) {
      setDisabled(true); // Disable the button after click
      if (onRetry) onRetry();
    }
  };

  return (
    <Box sx={{
      position: 'relative',
      padding: 1,
      minWidth: 200,
    }}>
      {/* Header with title and navigation */}
      <Box sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 1,
      }}>
        {/* Title */}
        <Typography
          sx={{
            fontSize: 12,
            fontWeight: 'bold',
            fontFamily: theme.fontFamily,
            color: theme.text.primary,
          }}
        >
          Error status
        </Typography>

        {/* Navigation controls and counter */}
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
        }}>
          <IconButton
            onClick={handlePrev}
            disabled={reasons.length <= 1}
            size="small"
            sx={{
              color: theme.text.primary,
              opacity: 0.7,
              padding: '2px',
              '&:hover': {
                opacity: 1,
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              },
            }}
          >
            <ChevronLeftIcon sx={{ fontSize: 16 }} />
          </IconButton>

          <Typography
            sx={{
              fontSize: 12,
              opacity: 0.7,
              fontFamily: theme.fontFamily,
              color: theme.text.primary,
            }}
          >
            {currentIndex + 1}/{reasons.length}
          </Typography>

          <IconButton
            onClick={handleNext}
            disabled={reasons.length <= 1}
            size="small"
            sx={{
              color: theme.text.primary,
              opacity: 0.7,
              padding: '2px',
              '&:hover': {
                opacity: 1,
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              },
            }}
          >
            <ChevronRightIcon sx={{ fontSize: 16 }} />
          </IconButton>
        </Box>
      </Box>

      {/* Content */}
      <Typography sx={{
        fontSize: 12,
        fontFamily: theme.fontFamily,
        color: theme.text.primary,
        px: 1,
        mb: 1,
      }}>
        {reasons[currentIndex]}
      </Typography>

      {/* Retry Button */}
      {onRetry && (
        <Box sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          mt: 1,
        }}>
          <Button
            startIcon={<RefreshIcon fontSize="small" />}
            onClick={handleRetry}
            size="small"
            variant="outlined"
            sx={{
              fontSize: 11,
              textTransform: 'none',
              fontFamily: theme.fontFamily,
              color: theme.text.primary,
              borderColor: theme.text.primary,
              opacity: 0.8,
              '&:hover': {
                opacity: 1,
                borderColor: theme.text.primary,
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              },
              py: 0.5,
              px: 1,
            }}
          >
            Retry
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default TooltipContent;